import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const pageContentCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;height:100%;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host main{align-content:flex-start;align-items:stretch;background-color:var(--jw-theme-surface-body-bg-color);display:flex;flex:1;flex-direction:column;flex-wrap:wrap;gap:1rem;padding:1.5rem 1.5rem 4rem}:host([fixed-min-width=true]){min-width:var(--jw-container-xl)}";

const WuiPageContent$1 = /*@__PURE__*/ proxyCustomElement(class WuiPageContent extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.fixedMinWidth = false;
    }
    render() {
        return (h(Host, { key: 'd8032f72604477f27899c49377dbba2b9f0046eb' }, h("main", { key: '2c35c3d1d6e3e3f9c72f27853fc6b3ffce8159ac' }, h("slot", { key: '5a346ef34b8bc26c9f41c4cfaff1ba9dc222859a' }))));
    }
    static get style() { return pageContentCss; }
}, [257, "wui-page-content", {
        "fixedMinWidth": [516, "fixed-min-width"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-page-content"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-page-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiPageContent$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiPageContent = WuiPageContent$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPageContent, defineCustomElement };
